module.exports = __webpack_public_path__ + "img/geistundgehirn.f735c725.png";